<template>
  <!-- Botão flutuante global: reabre o tour da página atual.
       O overlay/spotlight/popover em si é renderizado pelo driver.js. -->
  <!-- salvia-778: aqui a raiz do componente ERA o proprio botao, entao o
       `v-if` precisa vir junto para o `v-tooltip`. Deixado no botao, o
       componente renderizaria sempre — e o dock, que conta filhos que
       renderizam para decidir se aparece, passaria a ver um atalho que nao
       existe. O `title` nativo sai, para nao duplicar a dica. -->
  <v-tooltip v-if="!active && registered" left>
    <template v-slot:activator="{ on, attrs }">
      <button
        class="gt-fab"
        aria-label="Abrir o tour desta página"
        v-bind="attrs"
        v-on="on"
        @click="replay"
      >
        <span class="gt-fab__q">?</span>
      </button>
    </template>
    <span>Tour desta página</span>
  </v-tooltip>
</template>

<script>
import tour from "@/features/tour/tourService";

export default {
  name: "GuidedTour",

  computed: {
    active() {
      return tour.state.active;
    },
    registered() {
      return tour.state.registered;
    },
  },

  methods: {
    replay() {
      tour.replayCurrent();
    },
  },
};
</script>

<style scoped>
/* Botão flutuante de replay — nível 1 da coluna de FABs (ver tokens.css --ds-fab-*). */
.gt-fab {
  position: fixed;
  right: var(--ds-fab-right, 24px);
  bottom: var(--ds-fab-bottom-1, 88px);
  z-index: var(--ds-fab-z, 95);
  width: var(--ds-fab-h-1, 44px);
  height: var(--ds-fab-h-1, 44px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid var(--ds-blue-100, #e2e8f0);
  background: var(--ds-white, #fff);
  color: var(--ds-primary, #3e8e73);
  box-shadow: 0 6px 18px rgba(15, 30, 25, 0.18);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.gt-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(15, 30, 25, 0.24);
}
.gt-fab__q {
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
}
</style>
